import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import {routing} from './app.routes';
import {Http, HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {LoginComponent} from './pages/login/login';
import {AuthenticationService} from './services/authentication.service';
import {AuthGuard} from './common/auth.guard';
import {AuthConfig, AuthHttp} from 'angular2-jwt';
import {CustomersComponent} from './pages/customer/customers.component';
import {
  CalendarModule, CheckboxModule, ConfirmationService, ConfirmDialogModule, DataTableModule, DialogModule,
  DropdownModule,
  ScheduleModule,
  SharedModule
} from 'primeng/primeng';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CustomersAddComponent} from './pages/customer/add/customer.add.component';
import {CustomerDetailsComponent} from './pages/customer/details/customer.details.component';
import {CustomerEditComponent} from './pages/customer/edit/customer.edit.component';
import {CustomerHistoryComponent} from './pages/customer/history/customer.history.component';
import {MachinesComponent} from './pages/machine/machines.component';
import {MachineDetailsComponent} from './pages/machine/details/machine.details.component';
import {MachinerHistoryComponent} from './pages/machine/history/machine.history.component';
import {MaintenanceDetailsComponent} from './pages/maintenance/details/maintenance.details.component';
import {MachineMaintenanceDetailsComponent} from './pages/machinemaintenance/details/machine.maintenance.details.component';
import {MachineAddComponent} from './pages/machine/add/machine.add.component';
import {MachineEditComponent} from './pages/machine/edit/machine.edit.component';
import {AdminUsersComponent} from './pages/admin/users/admin.users.component';
import {UsersDetailsComponent} from './pages/admin/users/details/users.details.component';
import {UsersAddComponent} from './pages/admin/users/add/users.add.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {AgendaComponent} from './pages/agenda/agenda.component';
import 'jquery';
import 'moment';
import 'fullcalendar';
import {TableModule} from 'primeng/table';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CustomersComponent,
    CustomersAddComponent,
    CustomerDetailsComponent,
    CustomerEditComponent,
    CustomerHistoryComponent,
    MachinesComponent,
    MachineDetailsComponent,
    MachinerHistoryComponent,
    MaintenanceDetailsComponent,
    MachineMaintenanceDetailsComponent,
    MachineAddComponent,
    MachineEditComponent,
    AdminUsersComponent,
    UsersDetailsComponent,
    UsersAddComponent,
    SettingsComponent,
    AgendaComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    DataTableModule,
    TableModule,
    SharedModule,
    ConfirmDialogModule,
    CheckboxModule,
    CalendarModule,
    DropdownModule,
    ScheduleModule,
    DialogModule,
    routing
  ],
  providers: [
    ConfirmationService,
    AuthGuard,
    AuthenticationService,
    {
      provide: AuthHttp,
      useFactory: authFactory,
      deps: [Http]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function authFactory(http: Http) {
  return new AuthHttp(new AuthConfig({
    headerName: 'x-access-token',
    headerPrefix: '',
    tokenName: 'token',
    tokenGetter: (() => localStorage.getItem('id_token')),
    noJwtError: false,
    noTokenScheme: true
  }), http);
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts